import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { techdocsFeedbackReadPermission } from '@internal/plugin-techdocs-feedback-common';

export const TechDocsFeedbackSidebarItem = () => {
  return (
    <RequirePermission
      permission={techdocsFeedbackReadPermission}
      errorPage={<></>}
    >
      <SidebarItem
        icon={FeedbackOutlinedIcon}
        to="/techdocs-feedback"
        text="Feedback"
      />
    </RequirePermission>
  );
};
